import { useMemo } from 'react';
import AccountSubscriptionService from 'js/Services/AccountSubscriptions/AccountSubscriptionService.js';

const useAccountSubscriptions = (authService) => {
    // Memoize the service so it doesn't get recreated on every render
    return useMemo(() => {
        return new AccountSubscriptionService(authService);
    }, [authService]);
};

export default useAccountSubscriptions;
